import { render, staticRenderFns } from "./WarehouseTabContent.vue?vue&type=template&id=c8677438"
import script from "./WarehouseTabContent.vue?vue&type=script&lang=js"
export * from "./WarehouseTabContent.vue?vue&type=script&lang=js"
import style0 from "./WarehouseTabContent.vue?vue&type=style&index=0&id=c8677438&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports